import { Browser } from '@capacitor/browser';
import { useRouter } from 'vue-router';
/**
 * Standard plugin to open a new window
 * @returns open window function
 */
const openWindowPlugin = () => {
    const vueRouter = useRouter();
    /**
     * Open window logic
     * @param param0 {
     *  name: route name,
     *  params: route params
     *  query: route query
     *  url: full url
     * }
     */
    function openWindow({ name, params, query, url }) {
        if (!url && name) {
            const route = { name };
            if (query)
                route.query = query;
            if (params)
                route.params = params;
            const resolved = vueRouter.resolve(route);
            url = `${process.env.domain.startsWith('http')
                ? ''
                : 'https://'}${process.env.domain}${resolved.fullPath}`;
        }
        if (url)
            void Browser.open({ url });
    }
    return { openWindow };
};
export { openWindowPlugin };
